import { useState, useCallback } from 'react';
import { OnlinePayment, VerifyPay } from '../apis/Api';
import { useAuth } from '../context/UserContext';
import toast from 'react-hot-toast';
import { useWalletContext } from '../context/walletContext';

//const RAZORPAY_KEY_ID = 'rzp_test_7ICUz3usamubEH';
const RAZORPAY_KEY_ID = 'rzp_live_pnTaS90CYs5ac1';

export const usePaymentController = () => {
  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentError, setPaymentError] = useState(null);
  const { useWallet , appliedCoupon } = useWalletContext();
  //console.log("applied bt payment",appliedCoupon)
 // const {user} = useAuth()  
  const handlePlaceBooking = async (paymentData) => {
    try {
      setBookingLoading(true);
      setBookingError(null);
      setPaymentError(null);
  

      const result = await OnlinePayment({cust_token:paymentData.cust_token,pay_method:paymentData.pay_method,totalPrice:paymentData.totalPrice});
      if (result.status === 200 && result.order?.id) {
        const response = await handleRazorpayPayment(
          result.order_id,
          result.order.id,
          result.order.amount,
          result.order.currency,
          paymentData.user
        );

        if (response.success) {
          return { status: 200, order_id: response.order_id };
        }
        
      } else {
        throw new Error(result.error || 'Failed to place booking');
      }
    } catch (error) {
      setBookingError(error.message);
      throw { status: error.status || 500 };
    } finally {
      setBookingLoading(false);
    }
  };

  const handleBookingRetry = useCallback(
    (paymentData) => {
      setBookingError(null);
      return handlePlaceBooking(paymentData);
    },
    [handlePlaceBooking]
  );
  

  const handleRazorpayPayment = async (order_id, razor_id, amount, currency , user) => {
    try {
      setPaymentLoading(true);
      setPaymentError(null);

      return new Promise((resolve, reject) => {
        const options = {           
          description: 'At Your Door Payment',
          image: 'https://atyourdoormobilerepairs.com/assets/images/logo-light/Mobile_logo.png',
          currency,
          key: RAZORPAY_KEY_ID,
          amount,
          name: 'At Your Door',
          order_id: razor_id,
          prefill: {
            email: user?.cust_email || '',
            contact: user?.cust_contact || '',
            name: `${user?.f_name || ''} ${user?.l_name || ''}`.trim(),
          },
          handler: async (response) => {
           // console.log(user[0].cust_token)
            try {
              const updatedPayData = {
                razorpay_order_id: razor_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                order_id,
               wallet: useWallet ? user?.wallet :0,
               voucher:appliedCoupon,
              cust_token:user?.cust_token || ""
              };
           //  console.log("updatedPayData",updatedPayData)
              const result = await VerifyPay(updatedPayData);
              if (result.status === 200) {
                resolve({ success: true, order_id });
              } else {
                reject(new Error('Payment verification failed'));
              }
            } catch (error) {
              reject(error);
            }
          },
          error: (error) => {
            toast.error('Payment failed');
            reject(error);
          },
       
          theme: { color: '#73B734' },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      });
    } catch (error) {
      setPaymentError(error.message);
      throw { success: false, error };
    } finally {
      setPaymentLoading(false);
    }
  };

  return {
    handlePlaceBooking,
    handleBookingRetry,
    bookingLoading,
    bookingError,
    setBookingError,
    paymentLoading,
    paymentError,
  };
};
